export const postRequest = async (url, method, body) => {
  const response = await fetch('/api' + url, {
    method: method,
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(body),
  }).then(function (response) {
    if (!response.ok) {
      return 'Error';
    }
    return response.json();
  });

  return response;
};

export const getRequest = async (url, method) => {
  const response = await fetch('/api' + url, {
    method: method,
    headers: {
      'content-type': 'application/json',
    },
  });

  var jsonData = await response.json();
  return jsonData;
};
